/**
 * Pojmenovaná časová období.
 *
 * Všechna období jsou zaokrouhlena na celé dny.
 * Začínají v 0:00 počátečního dne (včetně) a končí 24:00 koncového dne (vyjma).
 */
enum SymbolicDate {
    /**
     * Dnes.
     *
     * - Začátek: Dnes.
     * - Konec:   Dnes.
     */
    TODAY = 'TODAY',

    /**
     * Dnes a budoucí týden.
     *
     * - Začátek: Dnes.
     * - Konec:   Týden do budoucnosti ode dneška.
     */
    TODAY_PLUS_WEEK = 'TODAY_PLUS_WEEK',

    /**
     * Dnes a budoucí 2 týdny.
     *
     * - Začátek: Dnes.
     * - Konec:   2 týdny do budoucnosti ode dneška.
     */
    TODAY_PLUS_TWO_WEEKS = 'TODAY_PLUS_TWO_WEEKS',

    /**
     * Dnes a budoucí týden.
     *
     * - Začátek: Dnes.
     * - Konec:   Měsíc do budoucnosti ode dneška.
     */
    TODAY_PLUS_MONTH = 'TODAY_PLUS_MONTH',

    /**
     * Dnes a budoucnost.
     *
     * - Začátek: Dnes.
     * - Konec:   Neomezeně.
     */
    TODAY_AND_FUTURE = 'TODAY_AND_FUTURE',

    /**
     * Dnes, minulý a budoucí týden.
     *
     * - Začátek: Týden do minulosti ode dneška.
     * - Konec:   Týden do budoucnosti ode dneška.
     */
    TODAY_PLUS_MINUS_WEEK = 'TODAY_PLUS_MINUS_WEEK',

    /**
     * Tento týden.
     *
     * - Začátek: Začátek aktuálního týdne.
     * - Konec:   Konec aktuálního týdne.
     */
    THIS_WEEK = 'THIS_WEEK',

    /**
     * Tento měsíc.
     *
     * - Začátek: Začátek aktuálního měsíce.
     * - Konec:   Konec aktuálního měsíce.
     */
    THIS_MONTH = 'THIS_MONTH',

    /**
     * Tento rok.
     *
     * - Začátek: Začátek aktuálního roku.
     * - Konec:   Konec aktuálního roku.
     */
    THIS_YEAR = 'THIS_YEAR',

    /**
     * Následující týden.
     *
     * - Začátek: Začátek následujícího týdne.
     * - Konec:   Konec následujícího týdne.
     */
    NEXT_WEEK = 'NEXT_WEEK',

    /**
     * Následující měsíc.
     *
     * - Začátek: Začátek následujícího měsíce.
     * - Konec:   Konec následujícího měsíce.
     */
    NEXT_MONTH = 'NEXT_MONTH',

    /**
     * Následující rok.
     *
     * - Začátek: Začátek následujícího roku.
     * - Konec:   Konec následujícího roku.
     */
    NEXT_YEAR = 'NEXT_YEAR',
}

export default SymbolicDate;
